import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { Utility } from '../../../common/utility';
import { ValidationService } from '../../../shared/services/validation.service';
import { Patient } from '../../../models/patient/patient.model'
import { AdminVaccineService } from './../admin-vaccine.service'
import { Subject } from 'rxjs/Subject';
import { BaseUrl } from '../../../shared/urls/base.url';
import * as moment from 'moment';
import { PatientUrl } from '../../../shared/urls/patient.url';

@Component({
  selector: 'other-admin-vaccine-received',
  templateUrl: './other-admin-vaccine-received.component.html',
  providers: [AdminVaccineService]
})
export class OtherAdminVaccineReceivedComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
  public appConstants = AppConstants;

  constructor(
    public utility: Utility,
    private formBuilder: FormBuilder,
    public baseService:BaseService,
    public dialogService:DialogService,
    private router: Router) {}

  ngOnInit() {
    $.fn.dataTable.ext.errMode = 'throw';
    const url = BaseUrl.BASE_URL + PatientUrl.PATIENT_GET_OTHER_ADMINISTEREDVACCINE;
    var self = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 15,
      searching: false,
      lengthChange: false,
      retrieve: true,
      serverSide: true,
      processing: false,
      ajax: {
        url: url,
        type: 'GET',
        beforeSend: function (request) {
            request.setRequestHeader('Content-Type', 'application/json');
            request.setRequestHeader('Accept', 'application/json');
            request.setRequestHeader('Authorization', 'bearer ' + BaseService.token);
        }
      },
      columns: [{
        title: 'Administer Date',
        data: 'administeredDate',
        render: function(data, type, row) {
          return moment(data).format('DD MMM YYYY');
        }
      }, {
        title: 'Vaccine',
        data: 'vaccineName'
      }, {
        title: 'Clinic',
        data: 'centre'
      }, {
        title: 'Batch No',
        data: 'batchNo'
      },
      {
        title: 'Status',
        data: 'status',
        render: function(data, type, row) {
          function onCheckExpiredDate(expireDate) {
            let today = new Date();
            let d = new Date(expireDate);
            let expiredMonth = (today.getFullYear() - d.getFullYear()) * 12;
            expiredMonth -= d.getMonth() + 1;
            expiredMonth += today.getMonth();
            return expiredMonth <= 0 ? 0 : expiredMonth;
          }

          let newData = '';
          if (row.monthCoverLeft && !row.isCourseInCompleted) {
            newData = '<span class="list-link-group">' + row.monthCoverLeft + ' Month(s) remaining</span>';
          }

          if (!row.monthCoverLeft && !row.isCourseInCompleted) {
            newData = '<span class="list-link-group status-01">' + onCheckExpiredDate(row.expireDate) + ' Month(s) expired</span>';
          }

          if (row.isCourseInCompleted) {
            newData = '<span class="list-link-group status-02">Incomplete course</span>';
          }

          return newData;
        }
      }, {
        title: 'Source',
        data: 'source'
      }
    ],
      language: {
        emptyTable: 'No vaccine record',
        info: 'Total _TOTAL_ vaccine(s)',
        infoEmpty: 'Total 0 vaccine(s)',
        processing: '<img src="../assets/images/spinner.gif" />'
      }
    };
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/admin-vaccine/other-admin-vaccine-received/other-admin-vaccine-received.component.ts